import React from 'react'
import { useTranslation } from 'react-i18next'
import { faTicket } from '@fortawesome/free-solid-svg-icons'

import { FaIcon } from '../../../App/Components'
import { IconListCard } from '../../../App/Components/IconTile/IconListCard'
import { useLocation, useParams } from '../../../Router'
import { useAppSelector } from '../../../store/hooks'
import { customerPortalLinks } from '../../../App/Util/customerPortalUrl'
import {
  IconTileContainer,
  IconTileIconContainer,
  IconTileText,
} from '../../../App/Components/IconTile/style'

type Props = {
  display: 'tile' | 'list'
}

const tileLinkStyle = {
  appearance: 'none' as const,
  background: 'transparent',
  border: 'none',
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  textDecoration: 'none' as const,
  color: 'inherit',
  display: 'block' as const,
}

export const PunchCardItem = ({ display }: Props) => {
  const location = useLocation()
  const { t } = useTranslation()
  const { establishmentId } = useParams<{ [key: string]: string }>()

  const settings = useAppSelector((state) => state.settings.values)

  const currentPath = location.pathname.replace(/\/+$/, '')
  const isRootPath =
    currentPath === `/${establishmentId}/menu` ||
    currentPath === `/${establishmentId}/activities`

  if (!settings?.onlinePunchCardSaleEnabled || !isRootPath) {
    return null
  }

  /*
   * OB-506: external Customer Portal URL. Native <a href> lets the browser
   * handle copy-link / cmd-click-new-tab; plain click navigates the current
   * tab to CP (same end result as the previous Linking.openURL).
   */
  const punchCardsUrl = customerPortalLinks.punchCards(establishmentId)

  if (display === 'list') {
    return (
      <IconListCard
        title={t('Punch Cards')}
        icon={faTicket}
        href={punchCardsUrl}
      />
    )
  }

  return (
    <IconTileContainer>
      <a href={punchCardsUrl} style={tileLinkStyle}>
        <IconTileIconContainer highlightcolor={settings.highlightColor}>
          <FaIcon size="3x" icon={faTicket} color={settings.highlightColor} />
        </IconTileIconContainer>
        <IconTileText>{t('Punch Cards')}</IconTileText>
      </a>
    </IconTileContainer>
  )
}
